import React from "react";
import { CustomizeGalleryPolaris } from "@customer-gallery/components/CustomerPortalLayout/CustomizeGalleryPolaris";
import { GalleryListCmp } from "@customer-gallery/components/GalleryPageCmp/GalleryList";
import LeftNavigation from "@customer-gallery/components/CustomerPortalLayout/LeftNavigation";
import { Box } from "@novel/shared/components/Box";
import { Frame, Navigation, SkeletonDisplayText, SkeletonThumbnail } from "@shopify/polaris";
import Logo from "@customer-gallery-public/logo.svg";
import Image from "next/legacy/image";
import Bg from "@customer-gallery-public/bg.jpg";
import { createGlobalStyle } from "styled-components";

// unsure why, but for SSR not working to have these styles in global JSX
const GlobalStyle = createGlobalStyle`
    .skeleton-nav-items > *:first-child {
        margin-left: 1rem;
        margin-right: -1.5rem;
        margin-bottom: 1rem;
    }

    .Polaris-SkeletonThumbnail::after {
        border-radius: 50%;
        background: -webkit-gradient(
            linear,
            left top,
            right top,
            color-stop(8%, rgba(220, 220, 220, 0.85)),
            color-stop(18%, rgba(220, 220, 220, 1)),
            color-stop(33%, rgba(220, 220, 220, 0.85))
        );
        background: linear-gradient(
            to right,
            rgba(220, 220, 220, 0.85) 8%,
            rgba(220, 220, 220, 1) 18%,
            rgba(220, 220, 220, 0.85) 33%
        );
        background-size: 800px 100px;
        animation: wave-squares 2s infinite ease-out;
    }

    .Polaris-SkeletonDisplayText__DisplayText {
        max-width: calc(100% - 2rem);
        width: 100%;
        margin-top: 1.5rem;
    }
    .Polaris-SkeletonDisplayText__DisplayText::after {
        background: -webkit-gradient(
            linear,
            left top,
            right top,
            color-stop(8%, rgba(220, 220, 220, 0.85)),
            color-stop(18%, rgba(220, 220, 220, 1)),
            color-stop(33%, rgba(220, 220, 220, 0.85))
        );
        background: linear-gradient(
            to right,
            rgba(220, 220, 220, 0.85) 8%,
            rgba(220, 220, 220, 1) 18%,
            rgba(220, 220, 220, 0.85) 33%
        );
        background-size: 800px 100px;
        animation: wave-squares 2s infinite ease-out;
        border-radius: 100px;
    }

    @keyframes wave-squares {
        0% {
            background-position: -468px 0;
        }
        100% {
            background-position: 468px 0;
        }
    }
`;
interface ISkeletonLoadingBackgroundProps {
  readonly children?: React.ReactNode;
}
const COLLECTION_SKELETON_LINE_AMOUNT = 4;
export function SkeletonLoadingBackground({
  children
}: ISkeletonLoadingBackgroundProps): JSX.Element {
  return <React.Fragment>
            <GlobalStyle />
            <Frame>
                <Image className="BgImage" src={Bg} layout="fill" priority alt="background image" />
                <LeftNavigation>
                    <div className="novel-config-nav-wrapper ">
                        <div className="novel-config-nav-container">
                            <Navigation location="/login">
                                <div className="flex flex-col nav-column novel-all-nav-items-container">
                                    <div className="novel-config-user-container flex-col mb-10">
                                        <SkeletonThumbnail size="large" />
                                        <SkeletonDisplayText size="medium" />
                                    </div>
                                    <span className="novel-navigation-section-title">Wallets</span>
                                    <Box className="skeleton-nav-items">
                                        <SkeletonDisplayText size="small" />
                                    </Box>
                                    <span className="novel-navigation-section-title">
                                        Collections
                                    </span>
                                    {Array(COLLECTION_SKELETON_LINE_AMOUNT).fill(null).map((x, index) => <Box className="skeleton-nav-items" key={`skeleton-${index}`}>
                                                <SkeletonDisplayText size="small" />
                                            </Box>)}
                                </div>
                                <div className="logo-container mt-5 mb-5 flex justify-start items-center relative mr-12 h-20">
                                    <Image src={Logo} alt="Logo" layout="fill" objectFit="contain" />
                                </div>
                            </Navigation>
                        </div>
                    </div>
                </LeftNavigation>
                <div className="main-app-container-wrapper-gallery w-full">
                    <div className="main-app-container-container">
                        <CustomizeGalleryPolaris>
                            <GalleryListCmp addresses={[]} unclaimedTokens={[]} skeleton />
                        </CustomizeGalleryPolaris>
                    </div>
                </div>
                {children}
            </Frame>
        </React.Fragment>;
}